( function ( $ ) {
	$( function () {
		const Accordion = function ( el, multiple ) {
			this.el = el || {};
			this.multiple = multiple || false;

			// Variables privadas
			const links = this.el.find( '.accordion-link' );
			// Evento
			links.on(
				'click',
				{ el: this.el, multiple: this.multiple },
				this.dropdown
			);
		};

		Accordion.prototype.dropdown = function ( e ) {
			const $el = e.data.el,
				$this = $( this ),
				$next = $this.next();

			$next.slideToggle( 200 );
			$this.parent().toggleClass( 'open' );

			if ( ! e.data.multiple ) {
				$el.find( '.accordion-content' )
					.not( $next )
					.slideUp()
					.parent()
					.removeClass( 'open' );
			}
		};
		new Accordion( $( '.accordion' ), false );
	} );
} )( jQuery );
